import style from "./coloboration.module.scss";
import Image from "next/image";
import SharedAnimation from "@components/shared/animation";
import { InView } from "react-intersection-observer";
import animations from "@styles/animations.module.scss";
import checkIcon from "/public/web-neobanking/check-icon.png";
import sticker_styles from "./sticker.module.scss";

interface Team {
  title: string;
  points: string[];
}

interface StatisticPoint {
  mainPoint: string;
  secondPoint: string;
}

interface IStatistics {
  statistics: {
    title: string;
    imageUrl: string;
    teams: Team[];
    points: StatisticPoint[];
  };
}

const WebCollaboration = ({ statistics }: IStatistics) => {
  return (
    <SharedAnimation
      render={(ref) => (
        <section className={`${style.section} ${style.section__statistics}`}>
          <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
              if (inView) {
                entry?.target.classList.add(animations.active);
              }
              return (
                <div
                  ref={ref}
                  className={`${style.container} ${animations.scroll__animation}`}
                >
                  <div className={`${style.container__statistics}`}>
                    <div className={style.statistics__title}>
                      {statistics.title}
                    </div>
                    <div className={style.statistics__wrapper}>
                      <div className={style.statistics__teams}>
                        {statistics.teams.map((item: any, index: any) => {
                          return (
                            <div
                              key={index}
                              className={style.statistics__teams__item}
                            >
                              <div className={style.statistics__teams__title}>
                                {item.title}
                              </div>
                              <div className={style.statistics__teams__list}>
                                {item.points.map((item: any, index: any) => {
                                  return (
                                    <div
                                      key={index}
                                      className={
                                        style.statistics__teams__list__item
                                      }
                                    >
                                      <div
                                        className={
                                          style.statistics__teams__list__item__image
                                        }
                                      >
                                        <Image
                                          sizes="24px"
                                          alt="checkIcon"
                                          layout={"fill"}
                                          src={checkIcon}
                                        />
                                      </div>
                                      {item}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                        <div
                          className={`${style.sticker_eye} ${sticker_styles.sticker__animation}`}
                        >
                          <Image
                            alt="eye-sticker"
                            src={statistics.imageUrl}
                            layout={"fill"}
                            sizes="400px"
                          />
                        </div>
                      </div>
                      <div className={style.statistics__points}>
                        {statistics.points.map((item: any, index:any) => {
                          return (
                            <div
                              key={index}
                              className={style.statistics__points__item}
                            >
                              <div
                                className={
                                  style.statistics__points__item__mainPoint
                                }
                              >
                                {item.mainPoint}
                              </div>
                              <div
                                className={
                                  style.statistics__points__item__secondPoint
                                }
                              >
                                {item.secondPoint}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              );
            }}
          </InView>
        </section>
      )}
    />
  );
};

export default WebCollaboration;
